// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__kt0Ha","loader--svg":"Loader_loader--svg__0whcS"};